import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../../Settings/constants";
export const NAMESPACE = "statistics";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export const STATISTICS_TYPE = {
    TASKS: "TASKS",
    SOURCE: "SOURCE"
};
export const FIELD_NAME_BY_TYPE = {
    [STATISTICS_TYPE.TASKS]: "MethodName",
    [STATISTICS_TYPE.SOURCE]: "SourceName"
};
